import React from "react";
import { motion } from "framer-motion";
import { hideAnimation, coursesAnimation } from "../animate";
import { useScroll } from "./useScroll";
import useWindowDimensions from "./useDimension";

const CoursesDetail4 = (props) => {
  const { width } = useWindowDimensions();
  const [element, controls] = useScroll(width < 1000 ? 0 : 0.25);

  return (
    <div className="details">
      <motion.div
        className="desc"
        variants={coursesAnimation}
        initial="hidden"
        animate={controls}
        ref={element}
      >
        <h2>
          <span>
            這堂課適合誰? <br />
            我可以在這堂課獲得什麼?
          </span>
        </h2>
        <div style={{ overflow: "hidden" }}>
          <motion.h5 variants={hideAnimation}>
            <span style={{ textDecoration: "underline" }}>
              完成這堂課之後，你能:
            </span>
          </motion.h5>
        </div>
        <ol>
          <li>
            準備好你自己回答<span>Coding Interview面試</span>中的問題
          </li>
          <li>
            能夠用程式碼表現出
            <span>
              「Bubble Sort」、「Insertion Sort」、「Selection Sort」、「Merge
              Sort」、「Heap Sort」、「Quicksort」
            </span>
            、還有其他排序演算法!
          </li>
          <li>
            學習8種不同的排序演算法，並了解其各自的使用時機、特性與優劣關係。
          </li>
          <li>
            學習並演練演算法設計技巧，例如:Pointer, Counter, Sliding Window,
            Divide and Conquer。
          </li>
          <li>了解並且證明主定理(Master Theorem)。</li>
          <li>了解基本的資料結構，例如: LinkedList、Stack、Queue。</li>
          <li>
            了解Hashtable的運作原理與計算公式，包含Multiplication Method and
            Division Method。
          </li>
          <li>
            學會圖形演算法，例如
            <span>
              「Floyd-Warshall 演算法 (Dynamic Programming)」、「Dijkstra's
              Algorithm」、「Depth First Traversal」、「Breadth First
              Traversal」
            </span>
            。
          </li>
        </ol>

        <br />

        <div style={{ overflow: "hidden" }}>
          <motion.h5 variants={hideAnimation}>
            <span style={{ textDecoration: "underline" }}>這堂課是設計給:</span>
          </motion.h5>
        </div>
        <ol>
          <li>對資料科學有興趣的開發工程師</li>
          <li>對網頁前端後端有興趣，能夠使用基本JavaScript的工程師</li>
          <li>正在大學就讀資訊工程、電腦科學、資料科學、數學的學生</li>
          <li>對於演算法與網路結構有興趣者</li>
          <li>想要學習資料結構與演算法的人</li>
          <li>想要轉職成為工程師的人</li>
          <li>不是資工本科系，但想要就讀或報考資工研究所的學生。</li>
        </ol>
      </motion.div>
      <div className="images">
        <img src={props.img} alt="" />
      </div>
    </div>
  );
};

export default CoursesDetail4;
